import MobileNotificationReducer, { mobileNotificationSlice } from "./slice";
export * from "./api";

export { MobileNotificationReducer, mobileNotificationSlice };
export const { setSelectedNotification, clearMobileNotifications } = mobileNotificationSlice.actions;
